import { ComponentType } from 'react';
import { SettingsTab } from '@/core/widget-navigation/export';

// Extra sections a feature module adds to a settings tab, registered from the
// composition root (src/app). The tab renders each one under its own section header.
export interface SettingsSection {
  tab: SettingsTab;
  id: string;
  title: string;
  Component: ComponentType;
}

const sections: SettingsSection[] = [];

export function registerSettingsSection(section: SettingsSection) {
  if (!sections.some(s => s.id === section.id)) sections.push(section);
}

export function getSettingsSections(tab: SettingsTab): SettingsSection[] {
  return sections.filter(s => s.tab === tab);
}
